<template>
    <div>
        <vapp-header btnClose btnContactPersonCreate></vapp-header>
        <div class="container pr-5 pb-5 pl-5 pt-2 d-flex flex-column">
            <div class="switch">
                <md-switch v-model="customer">Customer</md-switch>
                <md-switch v-model="supplier">Supplier</md-switch>
            </div>
            <form class="w-100 form-fnc" autocomplete="off">
                <label>First Name*</label>
                <div class="input-group">
                    <input type="text" class="form-control padding-override" placeholder="John" v-model="first_name"
                           v-bind:class="{ 'is-invalid': attemptSubmit && missingFirstName }" v-on:input="updateDisplayName">
                    <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'first_name'">{{ error.text }}</div>
                </div>

                <label>Last Name</label>
                <div class="input-group">
                    <input type="text" class="form-control padding-override" placeholder="Cena" v-model="last_name" v-on:input="updateDisplayName">
                </div>

                <label>Display name*</label>
                <div class="input-group">
                    <input type="text" class="form-control padding-override" placeholder="john117" v-model="display_name"
                           v-bind:class="{ 'is-invalid': attemptSubmit && missingDisplayName }">
                    <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'display_name'">{{ error.text }}</div>
                </div>

                <label>Email</label>
                <div class="input-group">
                    <input type="email" class="form-control padding-override" placeholder="john@unsc.gov" v-model="email"
                           v-bind:class="{ 'is-invalid': attemptSubmit && invalidEmailFormat }">
                    <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'email'">{{ error.text }}</div>
                </div>

                <label>Phone Number</label>
                <div class="input-group">
                    <input type="number" class="form-control padding-override" placeholder="Please enter a valid number" v-model="phone_no">
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        
        name: "CreateNewPerson",
        data() {
            return {
                //Person
                display_name: null,
                first_name: "",
                last_name: "",
                email: null,
                phone_no: null,
                customer: false,
                supplier: false,

                //Others
                attemptSubmit: false,
                errors: [],
            }
        },
        computed: {
            ...mapState('company', ['selectedCompany']),
            missingDisplayName: function () {
                if (!this.display_name) { return true; } else { return false; }
            },
            missingFirstName: function () {
                if (!this.first_name) { return true; } else { return false; }
            },
            missingLastName: function () {
                if (!this.last_name) { return true; } else { return false; }
            },
            missingEmail: function () {
                if (!this.email) { return true; } else { return false; }
            },
            invalidEmailFormat: function () {
                if (this.email) { if (!this.validEmail(this.email)) { return true; } else { return false; } }
            },
            missingPhoneNo: function () {
                if (!this.phone_no) { return true; } else { return false; }
            },
            requestData: function() {
                return {
                    owner_id: this.selectedCompany,
                    entity: {
                        display_name: this.display_name,
                        email: this.email,
                        phone_no: this.phone_no,
                        first_name: this.first_name,
                        last_name: this.last_name,
                    },
                    is_customer: this.customer,
                    is_supplier: this.supplier,
                    memo: null,
                    currency_id: null,
                    method_id: null,
                    term_id: null,
                    send_mail: true,
                    addresses: [],
                    files: [null],
                    extras: [],
                    supplier_currency_id: null,
                    supplier_method_id: null,
                    supplier_term_id: null
                }
            }
        },
        mounted() {
            console.log("Mounted : CreatePerson");
            this.$root.$emit('show-loading', true);
            this.axios.get("/pre_sign_up").then(response => {
                this.$root.$emit('show-loading', false);
                this.currencies = response.data.currencies
            }).catch(error => {
                this.$root.$emit('show-loading', false);
                this.$generalAPIErrorHandling(error, this.$router);
            });

            // Will get call when user click on tick button top right
            // Do checking for compulsory fields first, then pop up confirmation dialog
            this.$root.$on('attempt_submit_create_person', vars => {
                this.errors = [];
                this.attemptSubmit = true;

                if (this.missingDisplayName) {
                    this.errors.push({id: 'display_name', text: "This field is compulsory"});
                }

                if (this.missingFirstName) {
                    this.errors.push({id: 'first_name', text: "This field is compulsory"});
                }

                if (!this.missingEmail && this.invalidEmailFormat) {
                    this.errors.push({id: 'email', text: 'Valid email required.'});
                }

                if(!this.errors.length) {
                    event.preventDefault();
                    this.$confirmationToast("Create Person?", "Are you sure you want to create this person?", this.createContact, null);
                } else {
                    event.preventDefault();
                }
            });
        },
        methods: {
            createContact() {
                this.$root.$emit('show-loading', true);
                this.axios({
                    method: 'post',
                    url: '/contacts/peoples',
                    data: this.requestData,
                }).then(response => {
                    console.log(response)
                    this.$root.$emit('show-loading', false);
                    this.$successToast('Person successfully created.')
                    this.$router.go(-1)
                }).catch(error => {
                    this.$root.$emit('show-loading', false);
                    this.$generalAPIErrorHandling(error, this.$router);
                })
            },
            getCurrencyId: function(country_id) {
                for (var i = 0; i < this.currencies.length; i++) {
                    if (this.currencies[i].country_id == country_id) {
                        let currency_id = this.currencies[i].id
                        return currency_id
                    }
                }
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            updateDisplayName() {
                this.display_name = this.first_name + " " + this.last_name;
            }
        },
    }
</script>

<style lang="scss">
    .input-group {
        margin-bottom: 25px;
    }

    .padding-override {
        padding-left: 15px !important;
    }
</style>
